// extracted by mini-css-extract-plugin
export default {"locked":"EditablePropWithDisable_locked__vkxe1","placeHolderShimmer":"EditablePropWithDisable_placeHolderShimmer__fw4Pd"};